import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const AppShell = styled.div`
	height: var(--app-height, 100dvh);
	max-height: var(--app-height, 100dvh);
	min-height: var(--app-height, 100dvh);
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	display: grid;
	grid-template-columns: ${THEME.sidebarWidth} minmax(0, 1fr);
	grid-template-rows: auto minmax(0, 1fr);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		grid-template-columns: 1fr;
		grid-template-rows: auto minmax(0, 1fr);
		padding-bottom: calc(
			${THEME.mobileNavHeight} + env(safe-area-inset-bottom, 0px)
		);
	}
`;

export const Main = styled.main`
	grid-column: 2;
	grid-row: 2;
	min-width: 0;
	min-height: 0;
	width: 100%;
	max-width: 100%;
	overflow-x: clip;

	&[data-scroll='main'] {
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior: contain;
		scroll-behavior: smooth;

		@media (max-width: ${THEME.mobileBreakpoint}) {
			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				display: none;
				width: 0;
				height: 0;
			}
		}
	}

	&[data-scroll='locked'] {
		overflow: hidden;
		display: flex;
		flex-direction: column;
		min-height: 0;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		grid-column: 1;
		grid-row: 2;
	}
`;
